// extracted by mini-css-extract-plugin
export var show = "video-module--show--7lMQM";
export var videoContainer = "video-module--videoContainer--EL7QA";
export var videoWrapper = "video-module--videoWrapper--ImowM";